module.exports = __webpack_public_path__ + "static/media/AccountInquiry.0d57666e.svg";